import { VStack } from 'tio-ui/components/layout';
import PageHeader from 'tio-ui/components/page-header';
import t from 'ember-intl/helpers/t';

<template>
  <VStack>
    <PageHeader @title={{t "strategy_finder_0726.title"}} />
    {{outlet}}
  </VStack>
</template>
